var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquilateralLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 81,
    viewBox: "0 0 71 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62 78.6396L36 63.6396L16 52.1396L5.5 46.1396L3 44.6396L1.94521 43.6396L0.972603 42.6396L0.486305 41.6396L0 40.6396V40.1396V39.6396L0.486305 38.6396L0.972603 37.6396L1.94521 36.6396L36.5 16.6396L54.5 6.13965L62.5 1.63965L65 0.639648H67L69.5 2.13965L70.5 4.13965L71 5.63965L71 45.1396V64.8896V74.7646V76.2793V77.2793L70.5 78.2793L69.5 79.2793L68.5 79.7793L67.5 80.1396H66L64 79.6396L62 78.6396Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquilateralLeft);
export default __webpack_public_path__ + "static/media/Equilateral_Left.e08eb7902c169344268b966e31e116d1.svg";
export { ForwardRef as ReactComponent };